<template>
  <div class="relative flex flex-col section-template w-screen h-90vh z-20 justify-center">
    <img class="h-screen ape-cable" src="/uploads/ape_cable.png" />
    <div class="flex flex-col justify-center items-center w-full sm:w-2/3 flex-1 text-left px-3 mx-auto">
      <img :src="content.image" class="redirect-thumbnail" :class="content.copyright && 'redirect-logo'" />
      <button
        @click="goTo(content.forwardLink)"
        class="mt-12 flex bg-black rounded-full text-white px-4 py-2 font-bold border border-black border-t-2 border-b-2 border-r-2 border-l-2 pointer-events-auto cursor-pointer button-style"
      >
        <section-redirect-icon class="mr-4" /><span>{{ $t(`sections.${content.id}.forwardButtonText`) }}</span>
      </button>
      <button
        v-if="!content.copyright"
        @click="toTop()"
        class="cursor-pointer mt-4 flex rounded-full text-white px-4 py-2 font-bold border border-white border-t-2 border-b-2 border-r-2 border-l-2 pointer-events-auto button-style"
      >
        <section-redirect-icon class="mr-4 transform rotate-180" /><span>{{
          $t(`sections.${content.id}.backwardButtonText`)
        }}</span>
      </button>
    </div>
    <p
      v-if="content.copyright"
      class="text-white text-center text-xs opacity-75 mb-12 sm:mb-0 px-4"
      v-html="$t(`sections.${content.id}.copyright`)"
    />
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import SectionRedirectIcon from "./SectionRedirectIcon";
import { getOtherDomain } from "../../domains";
export default {
  name: "SectionImageRedirect",
  components: {
    SectionRedirectIcon,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
    nextSection: {
      type: String,
      required: false,
    },
    animated: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mounted() {
    gsap.registerPlugin(ScrollToPlugin);
    gsap.registerPlugin(ScrollTrigger);
    this.animated && this.setScrollAnimation();
  },
  methods: {
    goTo(link) {
      if (this.content.copyright || link.substring(0, 4) === "http") {
        window.open(`${link}/${this.$i18n.locale}`, "_self");
      } else {
        window.open(`${getOtherDomain(this.$i18n.locale)}${link}`, "_self");
      }
    },
    toTop() {
      if (this.$device.ios || this.$device.android) {
        let beginning = document.querySelector(".section-large");
        beginning.scrollIntoView({ inline: "start", block: "start", behavior: "smooth" });
      } else {
        const panelsSection = document.getElementById("horizontal-desktop");
        const targetElem = document.querySelector(".section-large");
        let sectionsWidth = 0;
        document.getElementsByClassName("section").forEach((section) => {
          let sectionEl = document.getElementById(section.id);
          sectionsWidth += sectionEl.offsetWidth;
        });

        const containerOffset =
          (panelsSection.offsetTop + targetElem.offsetLeft) * (sectionsWidth / (sectionsWidth - window.innerWidth));

        gsap.to(window, {
          scrollTo: {
            y: containerOffset,
            autoKill: false,
          },
          duration: 1,
        });
      }
    },
    setScrollAnimation() {
      const sectionId = `#${this.content.id}`;

      gsap.from(sectionId, {
        scrollTrigger: { trigger: sectionId, toggleActions: "play pause resume reset" },
        duration: 2,
        opacity: 0,
        y: 200,
      });
    },
  },
};
</script>

<style lang="postcss" scoped>
p a {
  @apply underline;
}

.h-90vh {
  height: 90vh;
}

@media screen and (max-height: 599px) {
  h2 {
    @apply text-xl mb-4;
  }
  p {
    @apply leading-tight text-tiny;
  }
  .scroll-button {
    @apply hidden;
  }
}

@media screen and (min-height: 600px) and (max-height: 812px) and (max-width: 420px) {
  .scroll-button {
    display: flex;
    bottom: 3vh;
  }
}

.ape-cable {
  position: absolute;
  left: -200px;
  z-index: 1000;
  pointer-events: none;
}

.redirect-thumbnail {
  max-width: 400px;
}
.redirect-logo {
  max-width: 300px;
}

@media screen and (max-width: 600px) {
  .redirect-thumbnail {
    max-width: 300px;
  }
  .redirect-logo {
    max-width: 200px;
  }
  .ape-cable {
    left: -170px;
  }
}

@media screen and (max-width: 400px) {
  .redirect-thumbnail {
    max-width: 250px;
  }
}

@media screen and (max-height: 450px) {
  .redirect-thumbnail {
    max-width: 200px;
  }
}
</style>
